module.exports = __webpack_public_path__ + "static/index-vega-carburanti-95ddb43052d71d4e9ae1723b3de6d033.png";